// This file was auto-generated by Fern from our API Definition.
export var EvaluatorRevisionDataInput;
(function (EvaluatorRevisionDataInput) {
    EvaluatorRevisionDataInput.Runtime = {
        Python: "python",
        Typescript: "typescript",
        Javascript: "javascript",
    };
})(EvaluatorRevisionDataInput || (EvaluatorRevisionDataInput = {}));
